import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { IRatingsState } from ".";

export enum RatingType {
    Experience = 1,
    RareDrawLuck = 2,
    EpicDrawLuck = 3,
    LegendaryDrawLuck = 4,
    SubscriptionRewardChallenge = 5,
}

export interface IRankItem {
    username: string;
    rank: number;
    value: number;
    avatar?: string;
    my?: boolean;
}

export interface IRatingData {
    name: string;
    type: RatingType;
}

export interface IRatingsResponse extends IRatingData {
    users: IRankItem[];
}

export const getRatings = createAsyncThunk<IRatingsResponse, RatingType>(
    'getRatings',
    async (type: RatingType) => await api.ratings.getRatings(type)
);

const getRatingsHandler = (builder: ActionReducerMapBuilder<IRatingsState>) => {
    builder
        .addCase(getRatings.pending, (state: IRatingsState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(getRatings.fulfilled, (state: IRatingsState, action: PayloadAction<IRatingsResponse>) => {
            state.loading = false;

            if (!action.payload)
                return;

            state.current = action.payload.type;
            state.users = action.payload.users ?? [];

        })
        .addCase(getRatings.rejected, (state: IRatingsState) => {
            state.loading = false;
            state.error = 'Unable to get ratings';
        });
};

export default getRatingsHandler;